import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalSelectOrganizations } from "./index";

export const useModalSelectOrganizations = () =>
  useWSModal(ModalSelectOrganizations, {
    title: "Grant organization account access",
    size: "M"
  });
